import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TrackGenre = ({ track, label }) => {
  if (!track.genre) {
    return null;
  }
  return (
    <span className={"fileunder " + (label ? "with-label" : "")}>
      {label && <span>File Under:</span>}
      {track.total_tracks_genre >= 5 && <FontAwesomeIcon icon="trophy" className="trophy fa-trophy" />}
      <Link to={`/genre/${track.genre_id}`}>{track.genre}</Link>
      &nbsp;
      <span className="num-in-genre" style={{ fontSize: "10px" }}>
        ( {track.total_tracks_genre} )
      </span>
    </span>
  );
};

TrackGenre.propTypes = {
  track: PropTypes.object.isRequired,
  label: PropTypes.bool
};

TrackGenre.defaultProps = {
  label: false
};

export default TrackGenre;
